/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  AfterViewInit,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  NgForm,
  Validators,
  UntypedFormGroup,
} from "@angular/forms";
import { ParentPortalService } from "app/services/parentPortal.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import * as moment from "moment";
import { FetchData, UserAccountMessages } from "app/shared/generalMethods";
import { InputValidation } from "app/shared/inputValidation";
import { AgeValidation } from "app/utilities/utility";
import { IAddMembership } from "app/interface/i-add-Membership";
import { MembershipRegistrationService } from "app/services/membership-registration.service";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { MatDialog } from "@angular/material/dialog";
import { EmailService } from "app/services/email.service";
import { MatStepper } from "@angular/material/stepper";

@Component({
  selector: "new-membership",
  templateUrl: "./new-membership-form.component.html",
  styleUrls: ["./new-membership-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NewMembershipFormComponent implements OnInit, AfterViewInit {
  @ViewChild("addMembershipNgForm") addMembershipNgForm: NgForm;
  @ViewChild("horizontalStepper") horizontalStepper: MatStepper;
  horizontalStepperForm: UntypedFormGroup;
  addMembershipForm: FormGroup;
  userRecord: any;
  parentNameFirebase = "";
  parentEmailFirebase = "";
  pageLoader: any;
  pageLoaderText: any;
  parentId = null;
  waiverText = "";
  policyText = "";
  policyYounger = "";
  policyElder = "";
  emergencyPersonName = "";
  todaysDate = moment().format("YYYY-MM-DD");
  isNameExist = false;
  nameErrorText = "";
  isChildExist = false;
  childNameErrorText = "";
  childMaxAge = 0;
  childMinAge = 0;
  agePlaceHolder = "";
  waiverLastUpdate = "";
  className = "";
  results: any;
  parentUid: any;
  policyLastUpdate = "";
  agreementText = "";
  objValueToCheck = { value: "" };
  parentNameReplicate = "";
  parentCityReplicate = "";
  parentAddress = "";
  parentCity = "";
  parentPostalCode = "";
  pinfo = { address: "" };
  completeProfile = "";
  obj = [];
  parentSignature = "";
  mediaDisclaimer = "";
  searchText: string = "";
  filteredSchools: { key: string; value: string }[] = [];
  filteredSchoolList = [];
  isRuralArea: boolean = false;
  imagePreviewParent: string | ArrayBuffer | null = null;
  imagePreviewChild: string | ArrayBuffer | null = null;
  imagePreviewEmergency: string | ArrayBuffer | null = null;
  imageError: boolean = false;
  selectedFile: File | null = null;
  communityName = "";

  constructor(
    private _fetchData: FetchData,
    private _formBuilder: FormBuilder,
    private _parentPortalService: ParentPortalService,
    private _snackBar: MatSnackBar,
    private _inputValidation: InputValidation,
    private _router: Router,
    private _ageValidation: AgeValidation,
    private _membershipRegistrationService: MembershipRegistrationService,
    private _userMessage: UserAccountMessages,
    private _getSalesforceDataService: GetSalesforceDataService,
    private _dialog: MatDialog,
    private _emailService: EmailService
  ) {}

  ngOnInit(): void {
    this.userRecord = this._fetchData.data;
    const storedCommunityId = localStorage.getItem("communityId");
    if (storedCommunityId) {
      const matched = this.userRecord.lstLocations.find(
        (loc) => loc.Id === storedCommunityId
      );
      if (matched) {
        this.communityName = matched.Name;
      }
    }
    if (
      this.userRecord.hasValidExternalAccount === true &&
      this.userRecord.hasParents === false
    ) {
      this.policyYounger = this.userRecord.lstPolicies[0].Policies__c;
      this.policyElder = this.userRecord.lstPolicies[1].Policies__c;
      this.waiverText = this.userRecord.lstPolicies[0].Waiver__c;
      this.waiverLastUpdate = moment(
        this.userRecord.lstPolicies[0].LastModifiedDate
      ).format("YYYY-MM-DD");
      this.parentId = "";
      this.childMaxAge = this.userRecord.lstAppSettings[0].Max_Age_of_Kid__c;
      this.childMinAge = this.userRecord.lstAppSettings[0].Min_Age_of_Kid__c;
      this.agreementText =
        this.userRecord.lstAppSettings[0].Policy_Agreement__c;
      this.agePlaceHolder =
        "Child age must be between " +
        this.childMinAge +
        " and " +
        this.childMaxAge;
      this.parentUid = this._fetchData.parentUID;
      const user = JSON.parse(localStorage.getItem("user"));

      this.parentNameFirebase = user ? user.displayName : "";
      this.parentEmailFirebase = user ? user.email : "";
      this.parentNameReplicate = this.parentNameFirebase;

      this.setFormValuesNew();
    } else {
      this.policyYounger = this.userRecord.lstPolicies[0].Policies__c;
      this.policyElder = this.userRecord.lstPolicies[1].Policies__c;
      this.waiverText = this.userRecord.lstPolicies[0].Waiver__c;
      this.waiverLastUpdate = moment(
        this.userRecord.lstPolicies[0].LastModifiedDate
      ).format("YYYY-MM-DD");
      this.parentId = this.userRecord.lstParents[0].Id;
      this.childMaxAge = this.userRecord.lstAppSettings[0].Max_Age_of_Kid__c;
      this.childMinAge = this.userRecord.lstAppSettings[0].Min_Age_of_Kid__c;
      this.agePlaceHolder =
        "Child age must be between " +
        this.childMinAge +
        " and " +
        this.childMaxAge;
      this.setFormValues();
    }

    // Initialize form listeners after form is created
    this.initializeFormListeners();

    this.getMediaDisclaimer();
    this.filteredSchoolList = [...this.userRecord.lstSchoolPicklist];
  }

  ngAfterViewInit(): void {
    // Stepper is now available, set up the selection change listener
    if (this.horizontalStepper) {
      this.horizontalStepper.selectionChange.subscribe((event) => {
        this.saveCurrentStepData(event.selectedIndex);
      });
    }
  }

  private initializeFormListeners(): void {
    if (!this.horizontalStepperForm) return;

    // Set up form value change listeners
    this.horizontalStepperForm.valueChanges.subscribe((value) => {
      this.autoSaveFormData();
    });

    // Set up individual control listeners
    for (const eachControl of Object.keys(
      this.horizontalStepperForm.value.step2
    )) {
      if (eachControl !== "isAgreeOnPolicy") {
        const eachFG = this.horizontalStepperForm.get("step2") as FormGroup;
        if (eachFG?.controls[eachControl]) {
          eachFG.controls[eachControl].valueChanges.subscribe((value) => {
            eachFG
              .get("isAgreeOnPolicy")
              ?.setValue(false, { emitEvent: false });
          });
        }
      }
    }

    // City change listener
    const cityControl = this.horizontalStepperForm.get("step1.pgiCity");
    if (cityControl) {
      cityControl.valueChanges.subscribe((city) => {
        this.parentCityReplicate = city;
        // Also update Step 4 liabilityOfName
        const liabilityOfNameControl = this.horizontalStepperForm.get(
          "step4.liabilityOfName"
        );
        if (liabilityOfNameControl) {
          liabilityOfNameControl.setValue(city);
        }
      });
    }
  }

  private saveCurrentStepData(nextStepIndex: number): void {
    switch (nextStepIndex) {
      case 0:
        this.btnProfileClicked();
        break;
      case 1:
        this.btnChildInfoClick();
        break;
      case 2:
        this.btnEmergencyContactClick();
        break;
      case 3:
        // Step 4 doesn't need separate saving
        break;
    }
  }

  autoSaveFormData(): void {
    if (!this.horizontalStepperForm) return;

    const formData = this.horizontalStepperForm.value;

    // Only save if form has values to prevent overwriting with empty data
    if (formData.step1?.pgiFullName) {
      localStorage.setItem(
        "membershipProfile",
        JSON.stringify([formData.step1])
      );
    }
    if (formData.step2?.fullName) {
      localStorage.setItem("childrenInfo", JSON.stringify([formData.step2]));
    }
    if (formData.step3?.contactName || formData.step3?.homePhone) {
      localStorage.setItem(
        "emergencyContacts",
        JSON.stringify([formData.step3])
      );
    }
  }
  private getHomePhoneFromUserProfiles(): string {
    try {
      // Get UID from localStorage
      const storedUID = localStorage.getItem("UID");

      if (!storedUID || !this.userRecord?.lstMemberOnboardings) {
        return "";
      }

      // Find matching user profile by User_UID_c
      const matchedProfile = this.userRecord.lstMemberOnboardings.find(
        (profile: any) => profile.Firebase_UID__c === storedUID
      );

      // Return the home phone number if found
      return matchedProfile?.Phone_Number__c || "";
    } catch (error) {
      console.warn("Error getting home phone from user profiles:", error);
      return "";
    }
  }
  filterSchool(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.filteredSchoolList = this.userRecord.lstSchoolPicklist.filter(
      (school) => school.value.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  setFormValues(): void {
    const autoHomePhone = this.getHomePhoneFromUserProfiles();
    this.horizontalStepperForm = this._formBuilder.group({
      step1: this._formBuilder.group({
        pgiFullName: [
          this.userRecord.lstParents[0]?.Name || "",
          [Validators.required],
        ],
        pgiCity: [
          this.userRecord.lstParents[0]?.Town_City__c === "null" ||
          !this.userRecord.lstParents[0]?.Town_City__c
            ? ""
            : this.userRecord.lstParents[0]?.Town_City__c,
        ],
        pgiHomePhone: [
          this.userRecord.lstParents[0]?.Home_Phone__c === "null" ||
          !this.userRecord.lstParents[0]?.Home_Phone__c
            ? ""
            : this.userRecord.lstParents[0]?.Home_Phone__c || autoHomePhone,
          [Validators.required],
        ],
        pgiEmail: [
          this.userRecord.lstParents[0]?.Parent_Email__c || "",
          [Validators.email, Validators.required],
        ],
        community: ["", [Validators.required]],
      }),
      step2: this._formBuilder.group({
        fullName: ["", [Validators.required]],
        gender: ["", [Validators.required]],
        dob: ["", [Validators.required]],
        community: [""],
        city: [this.parentCity],
        childAge: [
          "",
          [
            Validators.required,
            Validators.max(this.childMaxAge),
            Validators.min(this.childMinAge),
          ],
        ],
        isSubsidies: [false],
        isAgreeOnPolicy: [true],
        isConsent: [false],
      }),
      step3: this._formBuilder.group({
        contactName: ["", [Validators.required]],
        homePhone: ["", [Validators.required]],
        emergencyImage: [
          this.userRecord.lstEmergencyContacts[0]?.EC_Image__c === "null" ||
          !this.userRecord.lstEmergencyContacts[0]?.EC_Image__c
            ? "assets/images/avatars/user.png"
            : this.userRecord.lstEmergencyContacts[0]?.EC_Image__c,
        ],
        canPickChild: [false],
      }),
      step4: this._formBuilder.group({
        liabilityIName: [
          this.userRecord.lstParents[0]?.Work_Phone__c === "null" ||
          !this.userRecord.lstParents[0]?.Work_Phone__c
            ? ""
            : this.userRecord.lstParents[0]?.Work_Phone__c,
        ],
        liabilityOfName: [
          this.userRecord.lstParents[0]?.Town_City__c === "null" ||
          !this.userRecord.lstParents[0]?.Town_City__c
            ? ""
            : this.userRecord.lstParents[0]?.Town_City__c,
        ],
        liabilityDate: [
          { value: moment().format("YYYY-MM-DD"), disabled: true },
          [Validators.required],
        ],
        liabilityParentSignature: ["", [Validators.required]],
      }),
    });

    // Re-initialize listeners after form creation
    this.initializeFormListeners();
  }

  onInputAlphabet(event: any): void {
    this._inputValidation.onInputAlphabet(event.target);
  }

  onInputNumeric(event: any): void {
    this._inputValidation.onInputNumeric(event.target);
  }

  onInputAlphaNumeric(event: any): void {
    this._inputValidation.onInputAlphaNumeric(event.target);
  }

  setFormValuesNew(): void {
    const storedCommunityId = localStorage.getItem("communityId");

    // Safely parse localStorage data with proper fallbacks
    const profileData = this.getSafeLocalStorageData("membershipProfile");
    const childrenData = this.getSafeLocalStorageData("childrenInfo");
    const emergencyData = this.getSafeLocalStorageData("emergencyContacts");
    const autoHomePhone = this.getHomePhoneFromUserProfiles();

    this.horizontalStepperForm = this._formBuilder.group({
      step1: this._formBuilder.group({
        pgiFullName: [
          profileData?.name || this.parentNameFirebase,
          [Validators.required],
        ],
        pgiEmail: [
          profileData?.email || this.parentEmailFirebase,
          [Validators.email, Validators.required],
        ],
        pgiCity: [profileData?.city || ""],
        pgiHomePhone: [
          profileData?.homePhone || autoHomePhone,
          [Validators.required],
        ],
        community: [storedCommunityId || "", [Validators.required]],
      }),
      step2: this._formBuilder.group({
        fullName: [childrenData?.childName || "", [Validators.required]],
        gender: [childrenData?.gender || "", [Validators.required]],
        dob: [childrenData?.dob || "", [Validators.required]],
        community: [
          childrenData?.community === "null" ? "" : childrenData?.community,
        ],
        city: [childrenData?.city === "null" ? "" : childrenData?.city],
        childAge: [
          childrenData?.childAge || "",
          [
            Validators.required,
            Validators.max(this.childMaxAge),
            Validators.min(this.childMinAge),
          ],
        ],
        isSubsidies: [childrenData?.isSubsidies || false],
        isAgreeOnPolicy: [true],
        isConsent: [childrenData?.isConsent || false],
      }),
      step3: this._formBuilder.group({
        contactName: [emergencyData?.contactName || ""],
        emergencyImage: [emergencyData?.emergencyImage || ""],
        homePhone: [emergencyData?.homePhone || ""],
        canPickChild: [emergencyData?.canPickChild || false],
      }),
      step4: this._formBuilder.group({
        liabilityIName: [this.parentNameFirebase, Validators.required],
        liabilityOfName: [this.parentCityReplicate, Validators.required],
        liabilityDate: [
          { value: moment().format("YYYY-MM-DD"), disabled: true },
          [Validators.required],
        ],
        liabilityParentSignature: ["", [Validators.required]],
      }),
    });

    // Re-initialize listeners after form creation
    this.initializeFormListeners();
  }

  // Helper method to safely get localStorage data
  private getSafeLocalStorageData(key: string): any {
    try {
      const data = localStorage.getItem(key);
      return data && data !== "null" ? JSON.parse(data)[0] || {} : {};
    } catch (error) {
      console.warn(`Error parsing ${key} from localStorage:`, error);
      return {};
    }
  }

  ageChange(selectedDateOfBirth: Date): void {
    if (!this.horizontalStepperForm) return;

    const formGroupStep2 = this.horizontalStepperForm.get("step2") as FormGroup;
    if (!formGroupStep2) return;

    const newAge = this._ageValidation.ageChange(selectedDateOfBirth);
    formGroupStep2.get("childAge")?.setValue(newAge);

    if (newAge < this.childMinAge || newAge > this.childMaxAge) {
      formGroupStep2.get("dob")?.setErrors({ ageRange: true });
    } else {
      formGroupStep2.get("dob")?.setErrors(null);
    }
    this.getPolicyByAge(newAge);
  }

  getDobErrorMessage(): string {
    if (!this.horizontalStepperForm) return "";

    const dobControl = this.horizontalStepperForm.get("step2.dob");
    if (!dobControl) return "";

    if (dobControl.hasError("required")) {
      return "Please enter a date of birth";
    }
    if (dobControl.hasError("ageRange")) {
      return `Please select age between ${this.childMinAge} and ${this.childMaxAge}`;
    }
    return "";
  }

  onFormSubmit(): void {
    if (!this.horizontalStepperForm) return;

    const formData = this.horizontalStepperForm.value;

    this.pageLoader = true;
    const body: IAddMembership = this.createMembershipRegistrationBody(
      formData,
      localStorage.getItem("UID"),
      true
    );

    this.pageLoaderText =
      this._fetchData.data.lstAppSettings[0].Loading_message__c;

    if (this.horizontalStepperForm.valid) {
      if (
        this._fetchData.isNewAccount === true ||
        this._fetchData.isRenewAccount === true
      ) {
        this._membershipRegistrationService
          .addMembershipRegistration(body)
          .subscribe({
            next: (response) => {
              const results: any = this._fetchData.parseIntoJSON(response.msg);

              if (results?.success === true) {
                this._fetchData.setLocalStorage(response.msg);
                localStorage.removeItem("membershipProfile");
                localStorage.removeItem("childrenInfo");
                localStorage.removeItem("emergencyContacts");

                // ✅ Build email payload
                const emailPayload = {
                  parentName: formData.step1.pgiFullName,
                  parentEmail: formData.step1.pgiEmail,
                };

                this._emailService
                  .sendParentMembership(emailPayload)
                  .subscribe();

                // ✅ Redirect
                const programId = localStorage.getItem("ProgramId");
                if (programId) {
                  this._router.navigate(["/program-registration"], {
                    queryParams: { programId },
                  });
                } else {
                  this._router.navigate(["/program-registration"]);
                }
              } else {
                this.pageLoader = false;
                this.openSnackBar("Please try again, record not saved.");
              }
            },
            error: () => {
              this.openSnackBar("Please try again, record not saved.");
              this.pageLoader = false;
              this.redirectUserToMaintenancePage();
            },
          });
      }
    }
  }

  redirectUserToMaintenancePage(): void {
    this._getSalesforceDataService.redirectUserToMaintenancePage();
  }

  openSnackBarNavigateToSchedule(): void {
    this.openSnackBar("Record has been saved successfully.");
    this._router.navigate(["/all-membership"]);
  }

  createMembershipRegistrationBody(
    formData,
    uid,
    ignoreValidation
  ): IAddMembership {
    const addMembershipRegistration: IAddMembership = {
      ignoreValidation: ignoreValidation,
      parentData: {
        parenIdOrUid: this.checkForStringNull(uid),
        parentName: this.checkForStringNull(formData.step1?.pgiFullName),
        parentEmail: this.checkForStringNull(formData.step1?.pgiEmail),
        parentCity: this.checkForStringNull(formData.step1?.pgiCity),
        parentCommunity: this.checkForStringNull(formData.step1?.community),
        parentHomePhone: this.checkForStringNull(formData.step1?.pgiHomePhone),
        isActive: true,
      },
      kidData: {
        kidName: this.checkForStringNull(formData.step2?.fullName),
        dateOfBirth:
          this.checkForDateNull(formData.step2?.dob)?.format("YYYY-MM-DD") ||
          "",
        gender: this.checkForStringNull(formData.step2?.gender),
        kidAge: this.checkForStringNull(formData.step2?.childAge),
        kidTownCity: this.checkForStringNull(formData.step2.city),

        isSubsidies: this.checkForBooleanNull(formData.step2?.isSubsidies),
        isAgreeOnPolicy: this.checkForBooleanNull(
          formData.step2?.isAgreeOnPolicy
        ),
        communityRegisteringFor: this.checkForStringNull(
          formData.step2.community
        ),
        isConsent: this.checkForBooleanNull(formData.step2?.isConsent),
      },
      emergencyContactData: {
        emergencyContactHomePhone: this.checkForStringNull(
          formData.step3?.homePhone
        ),
        canPickChild: this.checkForBooleanNull(formData.step3?.canPickChild),
        emergencyContactName: this.checkForStringNull(
          formData.step3?.contactName
        ),
        emergencyImage: this.checkForStringNull(formData.step3?.emergencyImage),
      },
      membershipFormData: {
        subscription: "Subscribe",
        glsDate:
          this.checkForDateNull(formData.step4?.liabilityDate)?.format(
            "YYYY-MM-DD"
          ) || moment().format("YYYY-MM-DD"),
        glsIName: this.checkForStringNull(formData.step4?.liabilityIName),
        glsOfName: this.checkCityForNull(formData.step4?.liabilityOfName),
        glsParentSignature: this.checkForStringNull(
          formData.step4?.liabilityParentSignature
        ),
        policyCheckBox: true,
      },
    };
    return addMembershipRegistration;
  }

  checkCityForNull(formData): any {
    // If form data is empty, try to get the current parent city from step1
    if (!formData || formData === "") {
      const currentParentCity =
        this.horizontalStepperForm?.get("step1.pgiCity")?.value;
      return currentParentCity || this.parentCityReplicate || "";
    }
    return formData;
  }

  checkForStringNull(formData): any {
    return formData === null ? "" : formData;
  }

  checkForBooleanNull(formData): any {
    return formData === null ? false : formData;
  }

  checkForDateNull(formData): any {
    return formData === null ? null : moment(formData);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openSnackBar(message: string) {
    this._snackBar.open(message, "Close", {
      duration: 6000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  checkEmergencyName(e): void {
    if (!this.horizontalStepperForm) return;

    this.objValueToCheck.value =
      this.horizontalStepperForm.value.step1?.pgiFullName || "";
  }

  checkChildName(e): void {
    if (!this.horizontalStepperForm) return;

    this.objValueToCheck.value =
      this.horizontalStepperForm.value.step1?.pgiFullName || "";
  }

  parentNameChange(e): void {
    this.parentNameReplicate = e.target.value;
  }

  parentCityChange(e): void {
    this.parentCityReplicate = e.target.value;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getPolicyByAge(childAge) {
    for (const policy of this.userRecord.lstPolicies) {
      if (childAge >= policy.Min_Age__c && childAge <= policy.Max_Age__c) {
        this.policyText = policy.Policies__c;
        this.policyLastUpdate = moment(policy.LastModifiedDate).format(
          "YYYY-MM-DD"
        );
        return childAge;
      }
    }

    this.policyText = "";
    this.policyLastUpdate = "";
    return childAge;
  }

  parentInfo(): void {
    if (!this.horizontalStepperForm) return;

    // FIXED: Check if controls exist before setting values
    const addressControl = this.horizontalStepperForm.get("step2.address");
    const cityControl = this.horizontalStepperForm.get("step2.city");
    const postalCodeControl =
      this.horizontalStepperForm.get("step2.postalCode");
    const communityControl = this.horizontalStepperForm.get("step2.community");

    const step1PhysicalAddress = this.horizontalStepperForm.get(
      "step1.pgiPhysicalAddress"
    );
    const step1City = this.horizontalStepperForm.get("step1.pgiCity");
    const step1PostalCode = this.horizontalStepperForm.get(
      "step1.pgiPostalCode"
    );
    const step1Community = this.horizontalStepperForm.get("step1.community");

    if (addressControl && step1PhysicalAddress) {
      addressControl.setValue(step1PhysicalAddress.value);
    }
    if (cityControl && step1City) {
      cityControl.setValue(step1City.value);
    }
    if (postalCodeControl && step1PostalCode) {
      postalCodeControl.setValue(step1PostalCode.value);
    }
    if (communityControl && step1Community) {
      communityControl.setValue(step1Community.value);
    }

    this.btnProfileClicked();
  }

  btnProfileClicked(): void {
    if (this.horizontalStepperForm?.get("step1")?.valid) {
      const step1Data = this.horizontalStepperForm.value.step1;
      this.obj = [
        {
          name: step1Data.pgiFullName,
          email: step1Data.pgiEmail,
          city: step1Data.pgiCity,
          community: step1Data.community,
          homePhone: step1Data.pgiHomePhone,
        },
      ];
      localStorage.setItem("membershipProfile", JSON.stringify(this.obj));
    }
  }

  btnChildInfoClick(): void {
    if (this.horizontalStepperForm?.get("step2")?.valid) {
      const step2Data = this.horizontalStepperForm.value.step2;
      this.obj = [
        {
          childName: step2Data.fullName,
          gender: step2Data.gender,
          dob: step2Data.dob,
          childAge: step2Data.childAge,
          isSubsidies: step2Data.isSubsidies,
          isAgreeOnPolicy: step2Data.isAgreeOnPolicy,
          isConsent: step2Data.isConsent,
          community: step2Data.communityRegisteringFor,
          kidTownCity: step2Data.kidTownCity,
        },
      ];
      localStorage.setItem("childrenInfo", JSON.stringify(this.obj));
    }
  }

  btnEmergencyContactClick(): void {
    const step3Data = this.horizontalStepperForm?.value.step3;
    if (step3Data) {
      this.obj = [
        {
          contactName: step3Data.contactName,
          homePhone: step3Data.homePhone,
          emergencyImage: step3Data.emergencyImage,
          canPickChild: step3Data.canPickChild || false,
        },
      ];
      localStorage.setItem("emergencyContacts", JSON.stringify(this.obj));
    }
  }

  getMediaDisclaimer(): void {
    this.mediaDisclaimer = this._userMessage.getDataOfMediaDisclaimer(
      this._fetchData
    );
  }

  onFileSelected(event: Event, type: string) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    // Always resize no matter the original size
    this.resizeImage(file, 800, 800)
      .then((resizedFile) => {
        this.handleFile(resizedFile, type);
      })
      .catch(() => {
        this.imageError = true;
      });
  }

  private handleFile(file: File, type: string) {
    this.imageError = false;

    const reader = new FileReader();
    reader.onload = () => {
      const imageData = reader.result as string;

      if (type === "parent") {
        this.imagePreviewParent = imageData;
        this.horizontalStepperForm
          ?.get("step1")
          ?.patchValue({ pgiParentImage: imageData });
      } else if (type === "emergency") {
        this.imagePreviewEmergency = imageData;
        this.horizontalStepperForm
          ?.get("step3")
          ?.patchValue({ emergencyImage: imageData });
      }
    };
    reader.readAsDataURL(file);
  }

  private resizeImage(
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e: any) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = img.width;
        let height = img.height;

        // Maintain aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height *= maxWidth / width));
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width *= maxHeight / height));
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx?.drawImage(img, 0, 0, width, height);

        // Compress + resize
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile);
            } else {
              reject(new Error("Resize failed"));
            }
          },
          "image/jpeg",
          0.7
        ); // force JPEG at 70% quality
      };

      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  }
}
